export const COLORS = {
  WHITE: '#ffffff',
  GRAY100: '#D0D5DD',
};

export const ERROR_STATUS_500 = 5;
export const ERROR_STATUS_401 = 401;
export const ERROR_MESSAGE = 'Something went wrong!';

export const FIELD_TYPES = {
  UPLOAD: 'upload',
  NUMBER: 'number',
  DROPDOWN: 'dropdown',
  EMAIL: 'email',
  TEXTAREA: 'textarea',
  DATE: 'date',
  CONSENT: 'consent',
};

export const MAX_FILE_SIZE = 10 * 1024 * 1024;

export const MOBILE_BREAKPOINT = 576;

export const DATE_FORMAT = {
  STANDARD_DATE: 'YYYY-MM-DD',
};

export const RESET = 'reset';

export const PRIMITIVE_TYPES = {
  STRING: 'string',
};

export const POPOVER_HEIGHT = 320;

export const DROP_DOWN = 'DROPDOWN';
export const UPLOAD = 'UPLOAD';
export const TEXT_AREA = 'TEXTAREA';
export const DATE_TYPE = 'DATE';
export const NUMBER = 'NUMBER';
export const EMAIL = 'EMAIL';
export const CONSENT = 'CONSENT';

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const STATUS = {
  ACTIVE: 'ACTIVE',
};

export const BOOOSTED_LEAD_PATH_MESSAGE_TYPES = {
  ERROR: 'BOOOSTED_LEAD_PATH_ERROR',
  HEIGHT: 'BOOOSTED_LEAD_PATH_HEIGHT',
  SCROLL_TO_TOP: 'BOOOSTED_LEAD_PATH_SCROLL_TO_TOP',
};

export const CARD_ACTIONS = {
  NEXT_STEP: 'NEXT_STEP',
  LEAD_FORM: 'LEAD_FORM',
  REDIRECT_URL: 'REDIRECT_URL',
};

export const VIEW_KEYS = {
  STEP: 'step',
  FORM: 'form',
  SUCCESS: 'success',
};

export const BACKGROUND_TYPES = {
  SOLID: 'SOLID',
  GRADIENT: 'GRADIENT',
  IMAGE: 'IMAGE',
};

export const GRADIENT_DIRECTION_MAP = {
  VERTICAL: 'to bottom',
  HORIZONTAL: 'to right',
};

export const DEFAULT_FONT_FAMILY = 'Inter Tight';
export const DEFAULT_WIDGET_PADDING = 40;
export const SUCCESS_SCREEN_AUTO_CLOSE = 6000;
export const TRANSITION_DURATION = 400;
export const DUPLICATE_CLICK_WINDOW = TRANSITION_DURATION;
// Browsers without requestIdleCallback (Safari) prefetch after a short pause instead.
export const PREFETCH_IDLE_FALLBACK_DELAY = 200;
export const READ_ONLY_PARAM_VALUE = 'true';
export const WINDOW_OPEN_FEATURES = 'noopener,noreferrer';
export const BOOOSTED_WEBSITE_URL = 'https://booosted.fi';
export const MAX_CARDS_PER_ROW = 4;
// Card widths and gap in px, mirrored from the stylesheet so rows can be balanced to what fits.
export const CARD_ROW_GAP = 16;
export const FULL_ROW_CARD_WIDTH = 240;
export const SHORT_ROW_CARD_WIDTH = 280;
export const SELECT_MENU_SELECTOR = '.select-field__menu';
export const PATH_TRAIL_SEPARATOR = ' › ';
// The finishing screen (form or link) counts as the last step of a branch.
export const PATH_END_STEP_COUNT = 1;
export const DEFAULT_REPLY_TO_EMAIL = 'noreply@booosted.com';

export const DEFAULT_LANGUAGE = 'en';
// Path texts are authored in the dashboard's primary language slot (DEFAULT_LANGUAGES_ENABLED = fi).
export const PATH_LANGUAGE = 'fi';
